import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import InputBox from "Components/InputBox";
import Loader from "Components/Loader";
import { AiOutlineDelete } from "react-icons/ai";
import uploadIcon from "../../Assets/Images/uploadIcon.svg";
import {
  addSparePartEntry,
  updateSparePartField,
  deleteSparePartEntry,
} from "../../Redux/Slices/Accessor/sparePartUploaderSlice";
import "./styles.scss";
import Button from "Components/Button";
import { multiUpload } from "../../Redux/Slices/User/userSlice";
import { MdDeleteOutline } from "react-icons/md";
import { compressImage } from "Services/Utils/imageCompression";
import PDFIcom from "../../Assets/Images/pdfImg.png";
import XlsIcon from "../../Assets/Images/xlsx.png";


const SparePartUploader = ({ isLoading, isEditable }) => {
  const dispatch = useDispatch();
  const spareParts = useSelector((state) => state.sparePartUploader.uploads);

  const handleFileChange = async (file, index) => {
    // const validExtensions = [".png", ".jpg", ".jpeg"];
    const validExtensions = [".png", ".jpg", ".jpeg", ".pdf", ".xlsx", ".xls"];
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
    const selectedFile = file instanceof FileList ? file[0] : file;
    const extension = "." + selectedFile.name.split(".").pop().toLowerCase();

    let error = "";
    if (!validExtensions.includes(extension)) {
      // error = "Invalid file type. Only .png, .jpg, .jpeg files are allowed.";
      error =
        "Invalid file type. Only images, PDF, and Excel files are allowed.";
    }
    let finalFile = selectedFile;

    // Compress image if it's over 1MB
    if (
      selectedFile.type.startsWith("image/") &&
      selectedFile.size > 1024 * 1024 &&
      file.size < MAX_FILE_SIZE
    ) {
      try {
        const compressedBlob = await compressImage(selectedFile, 1);
        finalFile = new File([compressedBlob], selectedFile.name, {
          type: compressedBlob.type,
          lastModified: Date.now(),
        });
      } catch (err) {
        console.log(err, "err");
        return;
      }
    }

    if (selectedFile.size > MAX_FILE_SIZE) {
      error = `File ${selectedFile.name} exceeds the 5 MB size limit.`;
    }

    if (error) {
      dispatch(
        updateSparePartField({ index, field: "uploadError", value: error })
      );
      return;
    }

    dispatch(updateSparePartField({ index, field: "uploadError", value: "" }));

    // Upload file and store URL
    const formData = new FormData();
    formData.append("files", finalFile);

    dispatch(
      multiUpload({
        files: formData,
        callBack: (uploadedFiles) => {
          const newFiles = Array.isArray(uploadedFiles)
            ? uploadedFiles
            : [uploadedFiles];
          const fileData = newFiles.map((file) => ({
            name: file.originalName || file.name,
            url: file.url,
          }));
          dispatch(
            updateSparePartField({ index, field: "photos", value: fileData })
          );
        },
      })
    );
  };

  const getFileType = (url) => {
    if (!url) return "unknown";
    if (url.endsWith(".pdf")) return "pdf";
    if (url.endsWith(".xlsx") || url.endsWith(".xls")) return "excel";
    if (url.endsWith(".png") || url.endsWith(".jpg") || url.endsWith(".jpeg"))
      return "image";
    return "unknown";
  };

  return (
    <div className="SparePartUploaderWrap my-4 p-2">
      <div className="d-flex justify-content-between">
        <h4 className="mb-3">
          {/* KG Spare Parts  */}
          Product Mapping
        </h4>
        {isEditable && (
          <Button
            onClick={() => dispatch(addSparePartEntry())}
            title="Add"
            titleStyle={{ fontSize: "14px", fontWeight: "600" }}
            buttonStyle={{ width: "60px", height: "36px", marginRight: "0px" }}
          />
        )}
      </div>
      {spareParts.map((item, index) => (
        <div className="sparePartUploaderContainer  my-2 py-4 px-3" key={index}>
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5>{index + 1}. Spare Part</h5>
            {isEditable && (
              <MdDeleteOutline
                onClick={() => dispatch(deleteSparePartEntry(index))}
                size={25}
                className="removeIcon ms-3"
              />
            )}
          </div>

          <div className="w-100 ">
            <div className="col-md-8">
              {isEditable ? (
                <InputBox
                  label="Product Name"
                  value={item.product_name}
                  onChange={(e) =>
                    dispatch(
                      updateSparePartField({
                        index,
                        field: "product_name",
                        value: e.target.value,
                      })
                    )
                  }
                  inputStyle={{
                    border: "1px solid #858485",
                    borderRadius: "4px",
                    height: "49px",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                  labelStyle={{
                    color: "#2E2E2E",
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                />
              ) : item?.product_name && item?.product_name?.length > 0 ? (
                item?.product_name
              ) : (
                "Product Name Not Available"
              )}
            </div>

            <div className="col-md-8 py-3">
              <label className="uploadLabel mb-2">File</label>
              <div className="filess">
                {isLoading ? (
                  <Loader />
                ) : (
                  <>
                    {isEditable &&
                      (!item.photos || item.photos.length === 0) && (
                        <>
                          <FileUploader
                            handleChange={(file) =>
                              handleFileChange(file, index)
                            }
                            name="file"
                            multiple={false}
                            classes="drop_area drop_zone"
                            disabled={!isEditable}
                          >
                            <p className="drag">
                              <span className="mx-2 my-1">
                                <img src={uploadIcon} alt="upload" />
                              </span>
                              Drag your file here or{" "}
                              <span className="here mx-2">Browse</span>
                            </p>
                          </FileUploader>

                          <div className="my-2 uploadNote">
                            {/* Note: Only images (JPG, PNG, JPEG) allowed. Max size: 5MB. */}
                            Note: Images (JPG, PNG, JPEG), PDF, and Excel files
                            allowed. Max size: 5MB.
                          </div>
                        </>
                      )}

                    {item.photos?.length > 0 ? (
                      <div className="uploaded-image-preview">
                        {/* <img
                          src={item.photos[0]?.url}
                          alt="uploaded"
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "6px",
                          }}
                        /> */}
                        {(() => {
                          const fileUrl = item.photos[0]?.url;
                          const type = getFileType(fileUrl);

                          if (type === "image") {
                            return (
                              <img
                                src={fileUrl}
                                alt="uploaded"
                                style={{
                                  width: "120px",
                                  height: "120px",
                                  objectFit: "cover",
                                  borderRadius: "6px",
                                }}
                              />
                            );
                          }

                          if (type === "pdf") {
                            return (
                              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                <img
                                  src={PDFIcom}
                                  alt="PDF"
                                  style={{ width: "75px", height: "auto" }}
                                />
                                <p style={{ marginTop: "6px" }}>Open PDF</p>
                              </a>
                            );
                          }


                          if (type === "excel") {
                            return (
                              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                <img
                                  src={XlsIcon}
                                  alt="Excel"
                                  style={{ width: "75px", height: "auto" }}
                                />
                                <p style={{ marginTop: "6px" }}>Open Excel</p>
                              </a>
                            );
                          }


                          return null;
                        })()}
                      </div>
                    ) : (
                      !isEditable && (
                        <p className="text-muted">No Files available.</p>
                      )
                    )}

                    {item.uploadError && (
                      <span className="text-danger fs-13 fw-500">
                        {item.uploadError}
                      </span>
                    )}
                  </>
                )}
              </div>

              <div className="uploaded-file-list">
                {item.photos?.length > 0 ? (
                  <div className="uploaded-file-name">
                    {/* <a href={item.photos[0]?.url} target="_blank" rel="noopener noreferrer"> */}
                    {item.photos[0]?.name ||
                      item.photos[0]?.url.split("/").pop()}
                    {/* </a> */}
                    {isEditable && (
                      <AiOutlineDelete
                        className="remove-icon"
                        onClick={() =>
                          dispatch(
                            updateSparePartField({
                              index,
                              field: "photos",
                              value: [],
                            })
                          )
                        }
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        color="#1f2155"
                        size={25}
                      />
                    )}
                  </div>
                ) : (
                  <p>No fiels uploaded yet.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SparePartUploader;
